import { render, staticRenderFns } from "./in_stock.vue?vue&type=template&id=9520bcde"
import script from "./in_stock.vue?vue&type=script&lang=js"
export * from "./in_stock.vue?vue&type=script&lang=js"
import style0 from "./in_stock.vue?vue&type=style&index=0&id=9520bcde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports